import { create } from 'zustand';

const useSupplierDetailsStore = create((set) => ({
  supplier: null,
  supplierContactInfo: null,
  supplierAddress: null,
  supplierEmissions: null,
  supplierCompanies: null,
  loading: false,

  setSupplierData: (data) =>
    set({
      supplier: data?.supplier || null,
      supplierContactInfo: data?.supplier
        ? {
            name: data?.supplier?.name,
            phoneNumber: data?.supplier?.phoneNumber,
            email: data?.supplier?.contactEmail,
          }
        : null,
      supplierAliases: data?.supplier?.aliases?.length
        ? { aliases: data.supplier.aliases.join(', ') }
        : null,
      supplierAddress: data?.supplier?.address
        ? {
            country: data?.supplier?.address?.country?.name,
            city: data?.supplier?.address?.city,
            state: data?.supplier?.address?.state,
            street: data?.supplier?.address?.street,
            addressNumber: data?.supplier?.address?.number,
          }
        : null,
      supplierEmissions: data?.emissions || null,
      supplierCompanies: data?.companies || null,
    }),

  setLoading: (isLoading) => set({ loading: isLoading }),

  resetState: () =>
    set({
      supplier: null,
      supplierContactInfo: null,
      supplierAliases: null,
      supplierAddress: null,
      supplierEmissions: null,
      supplierCompanies: null,
      loading: false,
    }),
}));

export default useSupplierDetailsStore;
